import { forwardRef, type Ref, type SVGProps } from "react";
const IconDownloadFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 22a2 2 0 0 0-2 2v2H6v-2a2 2 0 0 0-4 0v3.5A2.5 2.5 0 0 0 4.5 30h23a2.5 2.5 0 0 0 2.5-2.5V24a2 2 0 0 0-2-2" />
    <path d="M13.83 22.05a3 3 0 0 0 4.34 0l5.29-5.69a2 2 0 1 0-2.92-2.72L18 16.36V4a2 2 0 0 0-4 0v12.36l-2.54-2.72a2 2 0 0 0-2.92 2.72z" />
  </svg>
);
const ForwardRef = forwardRef(IconDownloadFilledSVG);
ForwardRef.displayName = "IconDownloadFilled";
export { ForwardRef as IconDownloadFilled };
